"use client";

import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { LinkIcon } from "lucide-react";
import { usePathname, useSearchParams } from "next/navigation";
import { CopyToClipboardButton } from "@/components/ui/copy-to-clipboard-button";
import { buildProductionUrl } from "./production-url";

/**
 * stg で見ている画面の production URL をコピーするボタンです。
 *
 * 顧客への共有やレポート貼り付けで stg URL が混ざる事故を防ぐため、
 * 現在地の path / query を維持したまま origin だけ production に差し替えます。
 * 表示は staging 限定で、判定は呼び出し側（WorkspaceHeader）が行います。
 */
export function ProductionUrlCopyButton() {
  const { t } = useLingui();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const productionUrl = buildProductionUrl(pathname, search);

  return (
    <CopyToClipboardButton
      variant="outline"
      size="sm"
      className="size-8 gap-1.5 px-0 @xl:w-auto @xl:px-2.5"
      textToCopy={productionUrl}
      tooltipText={t(msg`Copy this page's production URL for sharing`)}
      successToastText={t(msg`Copied the production URL`)}
    >
      <LinkIcon className="size-4" />
      <span
        aria-hidden="true"
        className="hidden text-xs font-medium leading-none @xl:inline"
      >
        {t(msg`Share URL`)}
      </span>
    </CopyToClipboardButton>
  );
}
